import request from '@/utils/request'
import qs from 'qs'

// 动态订单
export const getDynamicList = () => {
  return request({
    url: '/api/lab/homedynamic',
    method: 'GET',
  })
}
// 订单图标数据(全部)
export const getOrderList = () => {
  return request({
    url: '/api/lab/homeOrder',
    method: 'GET',
  })
}
// 订单图标数据(某一年)
export const getOrderForYear = (year) => {
  return request({
    url: `/api/lab/homeOrder/${year}`,
    method: 'GET',
  })
}
// 企业排名
export const getEnterpriseRanking = (year) => {
  return request({
    url: `/api/lab/homeOrders/${year}`,
    method: 'GET',
  })
}
// 每年的积分：String
export const getIntegral = (year) => {
  // year 为 '' 时，获取全部积分
  return request({
    url: `/api/lab/homePoints/${year}`,
    method: 'GET',
  })
}
// 获取首页实时数据
export const getRealTimeData = (data) => {
  return request({
    url: `/api/lab/homeRealTimeData`,
    method: 'POST',
    data
  })
}
// 用户第一次下单年
export const getYearArr = () => {
  return request({
    url: '/api/lab/getYear',
    method: 'GET',
  })
}
// // 积分
// export const pointsFilter = () => {
//   return request({
//     url: '/api/lab/getYear',
//     method: 'GET',
//   })
// }
